"use client";
import { withAuth0 as withAuth0V2Raw } from "auth0-react-v2";

import { withAuth } from "@stadium/services/auth/client";

import { IS_AUTH0_ENABLED } from "@stadium/services/auth0/constants";

export {
  /**
   * @deprecated Use useAuth0V2 from services/auth0".
   */
  useAuth0,
  /**
   * @deprecated Use withAuth0V2 from services/auth0".
   */
  withAuth0,
} from "@auth0/auth0-react";

export type { RedirectLoginOptions } from "auth0-react-v2";

export { AuthServiceProvider, AuthServiceProviderV2 } from "./provider";

export {
  LOGIN_CALLBACK_ROUTE,
  LOGOUT_CALLBACK_ROUTE,
  PROXY_LOGOUT_CALLBACK_ROUTE,
} from "./constants";

export { onRedirectCallback, getAuth0ReturnToRoute, logoutUrl, useAuth0V2 } from "./utils/index";

export { CheckAuthHoc, CheckAuthHocV2 } from "./hoc/check-auth-hoc";

export const withAuth0V2 = (() => {
  if (IS_AUTH0_ENABLED) return withAuth0V2Raw;
  return withAuth;
})();
